import { render, staticRenderFns } from "./MainMenuDesktop.vue?vue&type=template&id=bf96aece&"
import script from "./MainMenuDesktop.vue?vue&type=script&lang=js&"
export * from "./MainMenuDesktop.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuDesktop.vue?vue&type=style&index=0&id=bf96aece&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports